import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Checkbox,
  FormControlLabel,
  Typography,
  Box,
} from '@mui/material';

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: string | React.ReactNode;
  confirmLabel: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onClose: () => void;
  /**
   * If you need “I Acknowledged” checkbox (used for delete) set requireAck = true.
   */
  requireAck?: boolean;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  title,
  message,
  confirmLabel,
  cancelLabel = 'Cancel',
  requireAck = false,
  onConfirm,
  onClose,
}) => {
  const [ack, setAck] = React.useState(false);

  const handleClose = () => {
    setAck(false);
    onClose();
  };

  const handleConfirm = () => {
    onConfirm();
    setAck(false);
  };

  return (
    <Dialog
      open={open}
      PaperProps={{
        sx: { borderRadius: '24px', padding: '30px' },
      }}
      onClose={handleClose}
      maxWidth='xs'
      fullWidth
    >
      <DialogTitle sx={{ textAlign: 'center', fontSize: 24 }}>
        {title}
      </DialogTitle>

      <DialogContent sx={{ textAlign: 'center' }}>
        {typeof message === 'string' ? (
          <Typography sx={{ fontSize: '16px', lineHeight: '24px' }}>
            {message}
          </Typography>
        ) : (
          message
        )}

        {requireAck && (
          <Box mt={2} display='flex' justifyContent='center'>
            <FormControlLabel
              control={
                <Checkbox
                  checked={ack}
                  onChange={(e) => setAck(e.target.checked)}
                />
              }
              label='I Acknowledge'
              sx={{
                m: 0,
                '& .MuiFormControlLabel-label': {
                  fontSize: 16,
                  color: 'black',
                },
              }}
            />
          </Box>
        )}
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'center', gap: 2, pb: 2 }}>
        <Button
          variant='outlined'
          disabled={requireAck && !ack}
          onClick={handleConfirm}
          sx={{
            textTransform: 'none',
            borderRadius: 100,
            px: 4,
            color: 'black',
            borderColor: 'black',
          }}
        >
          {confirmLabel}
        </Button>
        <Button
          variant='contained'
          onClick={handleClose}
          sx={{
            textTransform: 'none',
            borderRadius: 100,
            px: 4,
            bgcolor: '#FF0050',
            '&:hover': { bgcolor: '#E6004F' },
          }}
        >
          {cancelLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
